Postlogin.CCISAssessment = Postlogin.CCISAssessment || {};
Postlogin.CCISAssessment.Item = function (itemData) {
    const me = itemData;
    let container;

    me.itemContainer = $(`#item-${me.itemIndex}`);
    me.response = itemData.response;
    me.language = Postlogin.CCISAssessment.getLanguageSetting();

    me.init = function () {
        me.renderItem();
    };

    me.renderItem = function () {
        // get which question we are on, then grab the HTML for the options.
        const currentItemIndex = Postlogin.CCISAssessment.getCurrentItemIndex();
        // eslint-disable-next-line no-nested-ternary
        const pastOrFutureClass = me.itemIndex < currentItemIndex ? 'past' : me.itemIndex > currentItemIndex ? 'future' : '';

        const optionsContainer = Postlogin.CCISAssessment.renderOptions(me.response, pastOrFutureClass);

        const pageContainer = document.querySelector('#page-container');
        const item = document.createElement('div');
        pageContainer.appendChild(item);

        const itemText = me.language === 'en' ? me.item_text : me[`item_text_${me.language}`];

        container = `
            <div class="item-container ${_.escape(pastOrFutureClass)}"
                id="item-${_.escape(me.itemIndex)}" data-item-id="${_.escape(me.itemIndex)}">
                <div class="item-wrapper">
                    <div class="question">
                        <h2 class="question-title">${_.escape(itemText)}</h2>
                    </div>
                    ${optionsContainer}
                </div>
            </div>
        `;

        // add this item container to the page - using plain JavaScript
        item.outerHTML = container;
        document.querySelectorAll(`#item-${me.itemIndex} .item-wrapper .item-option`).forEach((option) => {
            option.addEventListener('click', (e) => {
                if (Postlogin.CCISAssessment.getAcceptingInput()) {
                    const selection = e.currentTarget.getAttribute('data-option-index');
                    Postlogin.CCISAssessment.setAcceptingInput(false);
                    me.makeSelection(selection);
                }
            });
        });

        document.querySelector(`#item-${me.itemIndex} .question`).addEventListener('click', () => me.speakQuestion());
    };

    me.makeSelection = function (selection) {
        const thisOption = $(container).find(`.item-option[data-option-index="${selection}"]`);
        const thisOptionId = thisOption.attr('data-option-id');
        const otherOptions = $(container).find(`.item-option:not([data-option-index="${selection}"])`);

        // no wrong answers!
        Postlogin.CCISAssessment.playSoundEffect('correct');
        $(otherOptions).removeClass('selected').addClass('not-selected');
        $(thisOption).removeClass('not-selected').addClass('selected');

        me.setCompleted();

        const userAssessmentId = Postlogin.CCISAssessment.getUserAssessmentId();

        // if this is a real assessment and not a preview... save the students response
        if (userAssessmentId != null && userAssessmentId > 0) {
            // selection: which option they selected
            // assessment_id: always 1 because CCIS-EZ
            // user_assessment_id: this paticular instance of the assessment
            // assessment_item_id: which question we're on
            const url = Slim.Router.urlFor('Assessment.CCIS.item.saveResponse', {
                assessment_id: me.assessment_id,
                user_assessment_id: userAssessmentId,
                item_id: me.assessment_item_id,
            });

            $.post(url, { assessment_option_id: thisOptionId }, (data) => {
                me.response = data;
            });
        }

        setTimeout(() => {
            me.advance();
        }, 750);
    };

    me.setCompleted = function () {
        // if this is the first time this item is being completed...
        if (!me.completed) {
            Postlogin.CCISAssessment.updateNumberComplete();
        }
        if (typeof Postlogin.CCISAssessment.Progress !== 'undefined') {
            Postlogin.CCISAssessment.Progress.completeItem(me.itemIndex);
        }

        me.completed = true;
    };

    me.advance = function () {
        if (!me.last) {
            // if on iOS device, force user to use next button
            // as this gets around the autoplay issue a bit
            const forceManualAdvance = $('body').hasClass('ios');

            if (forceManualAdvance) {
                Postlogin.CCISAssessment.showNextButton();
            } else {
                Postlogin.CCISAssessment.nextItem();
            }
        }
    };

    me.show = function () {
        me.setup();
        me.speakQuestion(500);
        $(window).trigger('resize');
        Postlogin.CCISAssessment.setAcceptingInput(true);
    };

    me.setup = function () {
        if (!me.first) {
            $('#previous-item').addClass('enabled');
        } else {
            $('#previous-item').removeClass('enabled');
        }

        if (!me.last && me.completed) {
            $('#next-item').addClass('enabled');
        } else {
            $('#next-item').removeClass('enabled');
        }
    };

    me.hide = function () {
        Postlogin.CCISAssessment.setAcceptingInput(false);
    };

    me.moveOutLeft = function () {
        $(`#item-${me.itemIndex}`).addClass('past');
        me.removeTabIndex();
    };

    me.moveOutRight = function () {
        $(`#item-${me.itemIndex}`).addClass('future');
        me.removeTabIndex();
    };

    me.moveInLeft = function () {
        $(`#item-${me.itemIndex}`).removeClass('future past');
        me.addTabIndex();
    };

    me.moveInRight = function () {
        $(`#item-${me.itemIndex}`).removeClass('past future');
        me.addTabIndex();
    };

    me.removeTabIndex = () => {
        $(`#item-${me.itemIndex}`).find('.item-option').removeAttr('tabindex');
    };

    me.addTabIndex = () => {
        $(`#item-${me.itemIndex}`).find('.item-option').attr('tabindex', 0);
    };

    me.isPlayPauseEnabled = function () {
        return me.play_pause_enabled;
    };

    me.getUserAssessmentItemId = function () {
        return me.user_assessment_item_id;
    };

    me.speakQuestion = (wait = 0) => {
        const itemAudio = me.language === 'en' ? me.item_audio : me[`item_audio_${me.language}`];
        // speak the instructions
        Postlogin.CCISAssessment.playSound(itemAudio, wait);
    };

    return me;
};
